import reducers from './reducers'

export { default as companiesTypes } from './types'
export { default as companiesActions } from './actions'
export { default as companiesSelectors } from './selectors'

export default reducers
